import { render, staticRenderFns } from "./placard_user.vue?vue&type=template&id=22da29e8&scoped=true"
import script from "./placard_user.vue?vue&type=script&lang=js"
export * from "./placard_user.vue?vue&type=script&lang=js"
import style0 from "./placard_user.vue?vue&type=style&index=0&id=22da29e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da29e8",
  null
  
)

export default component.exports